import styled from '@emotion/styled'
import React from 'react'
import {
    PRIMARY_ICON_COLOR_VAR,
    PRIMARY_PAGE_FILL_COLOR_VAR,
} from '../../context/CustomizationContextProvider'
import { CloseIcon } from '../icons/Close'
import { OVERLAY_CLOSE_BUTTON } from './overlayModal'

/**
 * Pins the button to the top of the panel whether the panel scrolls or a box
 * inside it does, and takes no height of its own: the panel leaves the room
 * for it, so content never starts underneath it.
 */
const Anchor = styled.div({
    position: 'sticky',
    top: 0,
    height: 0,
    width: '100%',
    zIndex: 3,
})

const Button = styled.button({
    position: 'absolute',
    top: OVERLAY_CLOSE_BUTTON.INSET_PX,
    right: OVERLAY_CLOSE_BUTTON.INSET_PX,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: OVERLAY_CLOSE_BUTTON.SIZE_PX,
    height: OVERLAY_CLOSE_BUTTON.SIZE_PX,
    padding: 0,
    border: 'none',
    borderRadius: '100%',
    cursor: 'pointer',
    background: `var(${PRIMARY_PAGE_FILL_COLOR_VAR})`,
    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.25)',
    '&:hover': {
        opacity: 0.7,
    },
})

export const OverlayCloseButton: React.FC<{ onClick: () => void }> = ({
    onClick,
}) => (
    <Anchor>
        <Button onClick={onClick} aria-label="Close">
            <CloseIcon
                width={22}
                height={22}
                fill={`var(${PRIMARY_ICON_COLOR_VAR})`}
            />
        </Button>
    </Anchor>
)
